import { DEFAULT_STATE } from '../constants'
import { searchPageStore } from '../index'

/**
 * Sets the animated filter
 * @param {boolean} animated - Whether to filter for animated models
 */
export const setAnimated = (animated) => {
  searchPageStore.setState({ animated })
}

/**
 * Sets the pbr filter
 * @param {boolean} pbr - Whether to filter for PBR models
 */
export const setPbr = (pbr) => {
  searchPageStore.setState({ pbr })
}

/**
 * Sets the rigged filter
 * @param {boolean} rigged - Whether to filter for rigged models
 */
export const setRigged = (rigged) => {
  searchPageStore.setState({ rigged })
}

/**
 * Clears all threeDOnly filters (sets all to false)
 */
export const clearThreeDOnly = () => {
  searchPageStore.setState({
    animated: DEFAULT_STATE.animated,
    pbr: DEFAULT_STATE.pbr,
    rigged: DEFAULT_STATE.rigged,
  })
}
